import { Injectable } from '@angular/core';
import {
    ConfigService,
    EntityService,
    TokenService
} from 'viggo-sistemas-core-web';
import { ICategoriaMaterial } from '../model/categoria_material.model';

@Injectable()
export class CategoriaMaterialService extends EntityService<
  ICategoriaMaterial
> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'categoria_material',
      pluralBaseEntityEndPoint: 'categorias_material'
    });
  }
}
